/* eslint-disable */

import {
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import React, {useState} from "react";
import {OpenInFull} from "@material-ui/icons";
import {CurrencyFormatter} from "../Utils/CurrencyFormatter";

const TablaPresSmall = ({ data, openTable, title }) => {
    const { header, rows } = data;

    console.log("dataTablePE", data)

    let myrows = data.rows

    const applyCase = (label) => {
    let labelSplitted = label.split(" ")
    let newLabel = []
    let exceptions = ["adm", "iva", "mp", "mp,", "mod", "cif", "i.e.s.s."]
    let prepositions = ['por', 'y', 'a', 'la', 'en', 'de', 'o', ]
    labelSplitted = labelSplitted.map((w, i) => {
      if(i != 0){
        if(exceptions.indexOf(w.toLowerCase()) != -1){
          newLabel.push(w.toUpperCase())
        }
        else if(prepositions.indexOf(w.toLowerCase())!= -1){
          newLabel.push(w.toLowerCase())
        }else{
          newLabel.push(w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
        }
      }else{
        newLabel.push(w)
      }
    })

    return newLabel.join(" ")
  }

  myrows = myrows.map((r,i) => {
    r.data[0]= applyCase(r.data[0])
    if(r.subRows.length > 0){
      r.subRows.map(sr => {
        sr.data[0] = applyCase(sr.data[0])
      })
    }
    return r
  })

    console.log("dataInternal", data)
    const [currentTable, setCurrentTable] = useState(false);

    
   
    const getCellStyle = (isBold) => ({
        fontWeight: isBold ? 700 : 400, // 700 para negrita, 400 para normal
        // color: isBold ? '#024788' : 'black', // Azul si es negrita, negro si no
        //fontSize: isBold ? 'larger' : 'inherit', // Tamaño de fuente más grande si es negrita
    });

    const handleOpenTable = () => {
        // Trigger the boolean value and pass it to the parent component
        const newValue = !currentTable; // toggle the value
        setCurrentTable(newValue);
        openTable(newValue);
    };

    const greyTitles = ["Compras MP, MOD y CIF", "Gastos de Ventas", "Gastos Administrativos", "Gastos de Inversión y Financiamiento", "Gastos No Operacionales"]
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ background: '#e7e8e8', color: '#42526E' }}>{title}</TableCell> {/* Columna de detalle*/}
                        {header.map((item, index) => (
                            <TableCell
                                key={index}
                                style={{ background: '#e7e8e8', color: index === 0 ? '#689DB8' : '#42526E', textAlign: 'center'}}
                            >
                                {item}
                            </TableCell>
                        ))}
                        {rows.length !== 0 && (
                            <TableCell style={{background: '#e7e8e8', color: '#42526E', padding: '16px 0', textAlign: 'center'}}>
                                <IconButton onClick={handleOpenTable}>
                                    <OpenInFull fontSize={"small"} sx={{ color: "#42526E"}}/>
                                </IconButton>
                            </TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, rowIndex) => (
                        <React.Fragment key={rowIndex}>
                            <TableRow
                                style={{
                                    background: row.data[0] === "Total entradas de efectivo" ||
                                    row.data[0] === "Total salidas de efectivo" ||
                                    row.data[0] === "Superavit-Deficit de requerimientos financieros Acumulativos"
                                        ? '#BEC2C3' // color de fondo especial para las filas especificadas
                                        : 'white' // color de fondo predeterminado
                                }}
                            >
                                {row.data.map((cell, cellIndex) => {

                                    return (
                                        <TableCell
                                            key={cellIndex}
                                            style={{
                                                background:
                                                    cellIndex === 0 && cell !== "" && cell !== 'Total entradas de efectivo'
                                                    && cell !== 'Total salidas de efectivo'
                                                    && cell !== 'Superavit-Deficit de requerimientos financieros Acumulativos' ?
                                                        '#EDF4FC' : cellIndex === 1 && '#689DB8',
                                                fontWeight: row.bold || cellIndex === 0 || cellIndex === 1 ? 'bold' : 'bold',
                                                color: row.bold || cellIndex === 0 ? 'black' : cellIndex === 1 ? 'white' : '#024788',
                                                textAlign: typeof cell === 'number' ? 'right' : 'inherit'
                                            }}
                                        >
                                            {cellIndex === 0 ? (
                                                <Typography sx={{ color: greyTitles.indexOf(cell) === -1 ? "black" : "gray" }} variant="inherit" className={row.bold ? 'bold' : ''}>
                                                    {cell}
                                                </Typography>
                                            ) : (
                                                typeof cell === 'number' ? <CurrencyFormatter value={cell}/> : cell
                                            )}
                                        </TableCell>
                                    );
                                })}
                                <TableCell style={{ background: row.data[0] === "Total entradas de efectivo" ||
                                    row.data[0] === "Total salidas de efectivo" ||
                                    row.data[0] === "Superavit-Deficit de requerimientos financieros Acumulativos"
                                        ? '#BEC2C3' // color de fondo especial para las filas especificadas
                                        : 'white', padding: '16px 0' }}></TableCell>
                            </TableRow>
                            {row.subRows &&
                            row.subRows.map((subRow, subRowIndex) => {
                                if (subRow.data[0] === "Totales Activo Corriente" ||
                                    subRow.data[0] === "Totales Activo No Corriente" ||
                                    subRow.data[0] === "Total Activo" ||
                                    subRow.data[0] === "Totales Pasivo Corriente" ||
                                    subRow.data[0] === "Totales Pasivo No Corriente" ||
                                    subRow.data[0] === "Total Pasivo " ||
                                    subRow.data[0] === "Total Pasivo + Patrimonio") {
                                    return (
                                        <TableRow key={`${rowIndex}-${subRowIndex}`}>
                                            {subRow.data.map((subCell, subCellIndex) => (
                                                <TableCell
                                                    key={subCellIndex}
                                                    style={{
                                                        background:
                                                            subCellIndex === 0 ? '#EDF4FC' : subCellIndex === 1 ? '#89B8CF' : 'white',
                                                        fontWeight: row.bold || subCellIndex === 0 || subCellIndex === 1 ? 'bold' : 'bold',
                                                        color: row.bold || subCellIndex === 0 ? 'black' : '#024788',
                                                        textAlign: typeof subCell === 'number' ? 'right' : subCellIndex === 0 ? 'left' : 'justify'
                                                    }}
                                                >
                                                    <div style={getCellStyle(subRow.bold)}>
                                                        <CurrencyFormatter value={subCell}/>
                                                        {subRow.bold}
                                                    </div>
                                                </TableCell>
                                            ))}
                                            <TableCell style={{ background: 'white', padding: '16px 0' }}></TableCell>
                                        </TableRow>
                                    )
                                }
                            })}
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default TablaPresSmall;